import type { ComponentProps } from 'react';
import cx from 'clsx';

import type ProductSalesTargetBadge from '~/domains/products/components/ProductSalesTargetBadge';

import { MembershipStandard22x12Icon } from '~/assets/icons';

const PlusMembershipProductBadge = ({
  salesTargets,
  className,
}: ComponentProps<typeof ProductSalesTargetBadge>) => {
  if (!salesTargets?.length) return <></>;

  return (
    <>
      {salesTargets[0] === 'CASHNOTE_PLUS' && (
        <div
          className={cx(
            'relative flex gap-4 items-center whitespace-nowrap typo-footnote300-semibold disable-text-size-adjust my-[2px]',
            className,
          )}
        >
          <MembershipStandard22x12Icon />
          <span className="text-[#008745]">멤버십 전용</span>
        </div>
      )}
    </>
  );
};

export default PlusMembershipProductBadge;
